export const LOADER_POSITIONHISTORY             =    'LOADER_POSITIONHISTORY';
export const GET_POSITIONHISTORY                =    'GET_POSITIONHISTORY';
export const POSITIONHISTORY_FAIL               =    'POSITIONHISTORY_FAIL';
export const SAVE_LOADER_POSITIONHISTORY        =    'SAVE_LOADER_POSITIONHISTORY';
export const FORM_POSITIONHISTORY_FAIL          =    'FORM_POSITIONHISTORY_FAIL';

